import { apiSlice } from "api/apiSlice";

import {
    createSelector,
    createEntityAdapter,
} from "@reduxjs/toolkit";

// const sizeFormatter = Intl.NumberFormat('en', { notation: 'compact' });
const reviewAdapter = createEntityAdapter({
    /*eslint-disable*/
    selectId: review => review.id,
})

const initialState = reviewAdapter.getInitialState({

        page: 0,
        filters: {},
        reviewsPerpage: 20,
        total_results: 0,
})

export const reviewApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getReview: builder.query({
            query: params => ({ url: `reviews`, params }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedReview = responseData.reviews.map(review => {
                    /* eslint-disable */
                    const newreview = review;
                    // newreview.salesShow = sizeFormatter.format(review.statistics?.sales);
                    return newreview
                });
                const returned =  reviewAdapter.upsertMany(
                    reviewAdapter.getInitialState({
                        page: responseData.page,
                        filters: responseData.filters ,
                        reviewsPerpage: responseData.reviewsPerpage,
                        total_results: responseData.total_results
                    })
                , loadedReview)
                return returned;
            },
            /* eslint-disable */
            providesTags: (result, error, id) => // [{ type: 'Review', arg }]
             {
                /* eslint-disable */
                if (result?.ids) {
                    return [
                        'Review',
                        { type: 'Review', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Review', id }))
                    ]
                } else return [{ type: 'Review', id: 'LIST' }, 'Review']
            },
            serializeQueryArgs({queryArgs}) {
                // Remove page-related arguments 
                if(!queryArgs)  return;
                const { page, ...otherArgs } = queryArgs;
                return otherArgs;
             },
             merge(currentCacheData, responseData) {

                 const cachToUpdate = !currentCacheData.entities ? reviewAdapter.getInitialState({
                     page: responseData.page,
                     filters: responseData.filters ,
                     reviewsPerpage: responseData.reviewsPerpage,
                     total_results: responseData.total_results,
                 }) : currentCacheData;

                 if( !responseData.ids ) 
                 {
                     reviewAdapter.upsertOne(
                         cachToUpdate,  
                         responseData
                     );
                     return;
                 }

                 reviewAdapter.upsertMany(
                     cachToUpdate,  
                     reviewsSelectors.selectAll(responseData)
                 );

                 currentCacheData.page = responseData.page;
                 currentCacheData.filters = responseData.filters ;
                 currentCacheData.reviewsPerpage = responseData.reviewsPerpage;
                 currentCacheData.total_results = responseData.total_results;
             },
        }),
				getProductReview: builder.query({
					query: params => ({ url: `productReviews`, params }),
					validateStatus: (response, result) => response.status === 200 && !result.isError,
					transformResponse: responseData => {
							const loadedReview = responseData.reviews.map(review => {
									/* eslint-disable */
									const newreview = review;
									// newreview.salesShow = sizeFormatter.format(review.statistics?.sales);
									return newreview
							});
							const returned =  reviewAdapter.upsertMany(
									reviewAdapter.getInitialState({
											page: responseData.page,
											filters: responseData.filters ,
											reviewsPerpage: responseData.reviewsPerpage,
											total_results: responseData.total_results
									})
							, loadedReview)
							return returned;
					},
					/* eslint-disable */
					providesTags: (result, error, id) => // [{ type: 'Review', arg }]
					 {
							/* eslint-disable */
							if (result?.ids) {
									return [
											'Review',
											{ type: 'Review', id: 'LIST' },
											...result.ids.map(id => ({ type: 'Review', id }))
									]
							} else return [{ type: 'Review', id: 'LIST' }, 'Review']
					},
					serializeQueryArgs({queryArgs}) {
							// Remove page-related arguments 
							if(!queryArgs)  return;
							const { page, ...otherArgs } = queryArgs;
							return otherArgs;
					 },
					 merge(currentCacheData, responseData) {

							 const cachToUpdate = !currentCacheData.entities ? reviewAdapter.getInitialState({
									 page: responseData.page,
									 filters: responseData.filters ,
									 reviewsPerpage: responseData.reviewsPerpage,
									 total_results: responseData.total_results,
							 }) : currentCacheData;

							 if( !responseData.ids ) 
							 {
									 reviewAdapter.upsertOne(
											 cachToUpdate,  
											 responseData
									 );
									 return;
							 }

							 reviewAdapter.upsertMany(
									 cachToUpdate,  
									 reviewsSelectors.selectAll(responseData)
							 );

							 currentCacheData.page = responseData.page;
							 currentCacheData.filters = responseData.filters ;
							 currentCacheData.reviewsPerpage = responseData.reviewsPerpage;
							 currentCacheData.total_results = responseData.total_results;
					 },
				}),
        getUserReview: builder.query({
            query: (id) => ({ url: `userReview/${id}` }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedReview = responseData;
                return loadedReview
            },
            /* eslint-disable */
            providesTags: (result, error, id) => [{ type: 'Review', id }],
        }),
        addNewReview: builder.mutation({
            query: initialReviewData => ({
                url: '/review',
                method: 'POST',
                body: {
                    ...initialReviewData,
                }
            }),
            invalidatesTags: [
                { type: 'Review', id: "LIST" }
            ]
        }),
        updateReview: builder.mutation({
            query: initialReviewData => ({
                url: '/review',
                method: 'PATCH',
                body: {
                    ...initialReviewData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Review', id: arg.id }
            ]
        }),
        reactToReview: builder.mutation({
            query: initialReviewData => ({
                url: '/reviewReact',
                method: 'PATCH',
                body: {
                    ...initialReviewData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Review', id: arg.id }
            ]
        }),
        deleteReview: builder.mutation({
            query: ({ id }) => ({
                url: `/review`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Review', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetReviewQuery,
		useLazyGetProductReviewQuery,
    useLazyGetReviewQuery,
    useGetUserReviewQuery,
    useAddNewReviewMutation,
    useUpdateReviewMutation,
    useReactToReviewMutation,
    useDeleteReviewMutation,
} = reviewApiSlice

// returns the query result object
export const selectReviewResult = reviewApiSlice.endpoints.getReview.select()

// creates memoized selector
const selectReviewData = createSelector(
    selectReviewResult,
    reviewResult => reviewResult.data // normalized state object with ids & entities
)
//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllreview,
    selectById: selectReviewById,
    selectIds: selectReviewIds
    // Pass in a selector that returns the review slice of state
} = reviewAdapter.getSelectors(state => selectReviewData(state) ?? initialState)
const reviewsSelectors = reviewAdapter.getSelectors((state) => state ?? reviewAdapter.getInitialState() );
export const selectReviewByUser = createSelector(
    [selectAllreview,(state, userId) => userId],
    (reviews, userId) => reviews.find(review => review.user === userId)
);
